import React, { useState } from "react";
import { Helmet } from "react-helmet";
import FsLightbox from "fslightbox-react";
import "../../../App.css"
import image2 from "../../../Img/Proyectos/ProyectosResidenciales/CasaPrado/61ce0501053ef6689e0a1899_428245_140459046076839_1342040686_n.jpg"
import image1 from "../../../Img/Proyectos/ProyectosResidenciales/CasaPrado/61ce0514f0cbc74910f3d059_424511_140460112743399_602624336_n.jpg"
import image3 from "../../../Img/Proyectos/ProyectosResidenciales/CasaPrado/61ce0546564555df1afc4ffa_426818_140459322743478_1886063120_n.jpg"
import image4 from "../../../Img/Proyectos/ProyectosResidenciales/CasaPrado/61ce0546f0cbc7beacf3d093_425133_140459179410159_1985967975_n.jpg"
import image5 from "../../../Img/Proyectos/ProyectosResidenciales/CasaPrado/61ce0553d0a0a53a06e83beb_ORNELAS 3.jpg"

function ProyectoCasaPrado() {

    const [toggler, setToggler] = useState(false);

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    function openLightboxOnSlide(number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number
        });
    }


    return (
        <>

            <Helmet>
                <title>Residencial - Casa Prado</title>
            </Helmet>


            <FsLightbox
                toggler={lightboxController.toggler}

                sources={[
                    image1, image2, image3, image4, image5
                ]}

                slide={lightboxController.slide}
            />
            <div className="container col-12 py-5">
                <div className="d-flex">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/proyectos-residenciales">Residenciales</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Casa Prado</li>
                        </ol>
                    </nav>
                </div>
                <h1 className="py-2 m-0 p-0">Casa Prado</h1>
            </div>

            <div className="container position-relative">
                <img onClick={() => openLightboxOnSlide(1)} type="button" src={image1} className="w-100" alt="..." height={650} />
            </div>


            <div className="container">
                <div className="row gy-4 mt-1">

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(2)}
                            src={image2}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(3)}
                            src={image3}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(4)}
                            src={image4}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(5)}
                            src={image5}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>
                    \
                </div>
            </div>
        </>
    );
}

export default ProyectoCasaPrado;
